import s from '../../styles/components/story/Origin.module.css';

export default function Origin({data}) {
    const { label, headline, paragraphs, pullQuote, pullQuoteAuthor, image, imageCaption } = data;

    return (
      <section className={s.section}>
        <div className={s.inner}>
          <div className={s.grid}>
            <div className={s.text}>
              {label && <span className={s.label}>{label}</span>}
              <h1 className={s.headline}>{headline}</h1>
              {paragraphs.map((p, i) => (
                <p key={i} className={s.body}>{p}</p>
              ))}
              {pullQuote && (
                <blockquote className={s.pullQuote}>
                  <span className={s.pullQuoteMark}>&ldquo;</span>
                  <span className={s.pullQuoteText}>{pullQuote}</span>
                  {pullQuoteAuthor && (
                    <cite className={s.pullQuoteAuthor}>— {pullQuoteAuthor}</cite>
                  )}
                </blockquote>
              )}
            </div>
            <div className={s.media}>
              <img src={image} alt="" className={s.image} />
              {imageCaption && <p className={s.caption}>{imageCaption}</p>}
            </div>
          </div>
        </div>
      </section>
    );
}